import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const employeeApi = createApi({
  reducerPath: 'employeeApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://onza-api.ibm.kg/api/employee/',
    prepareHeaders: (headers, { getState }) => {
      // Получаем токен из Redux state
      let { auth: { auth } } = getState();
      if (typeof auth == "string") {
        auth = JSON.parse(auth);
      }
      headers.set("Authorization", `Bearer ${auth?.accessToken}`);
      return headers;
    },
  }),
  tagTypes: ["employee"],
  endpoints: (builder) => ({
    getEmployee: builder.query({
      query: () => `employeeList`,
      providesTags: ["employee"],
    }),
    createOrUpdateEmployee: builder.mutation({
      query: (formData) => {
        return {
          url: `createEditEmployee`,
          method: 'POST',
          body: formData
        }
      },
      invalidatesTags: ["employee"],
    }),
    deleteEmployee: builder.mutation({
      query: (guid) => {
        return {
          url: `deleteEmployee`,
          method: 'DELETE',
          params: { employee_guid: guid },
        }
      },
      invalidatesTags: ["employee"],
    })
  }),
})

export const { useGetEmployeeQuery, useCreateOrUpdateEmployeeMutation, useDeleteEmployeeMutation } = employeeApi